import { makeStyles, darken, fade } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  // Keep the container spacing behaving natively
  resultsContainer: {
    padding: theme.spacing(0, 3),
    width: "100%",
    boxSizing: "border-box",
    [theme.breakpoints.up("md")]: {
      paddingRight: theme.spacing(1),
    },
  },
  resultTable: {

    borderCollapse: "collapse",
    boxSizing: "border-box",
    margin: 0,
  },
  thHeader: {
    backgroundColor: theme.palette.header,
    color: theme.palette.amano.base.main,
    fontWeight: "bold",
  },
  resultHeader: {
    textAlign: "left",
  },
  column: {
    verticalAlign: "middle",
  },
  pagination: {
    marginTop: "10px",
    display: "flex",
    justifyContent: "flex-end",
  },
  noResults: {
    marginTop: 50,
    textAlign: "center",
    width: "98%",
    "& .no-results-text": {
      border: "1px solid",
      borderColor: darken(theme.palette.amano.warnings.fire, 0.3),
      padding: "8px 92px 8px 92px",
      backgroundColor: theme.palette.background.paper,
      fontSize: "14pt",
      fontStyle: "italic",
      fontWeight: "bold",
      color: darken(theme.palette.amano.warnings.fire, 0.2),
      opacity: 0.7,
      borderRadius: 3,
      boxShadow: theme.shadows[2],
    },
  },
  thumbnail: {
    width: 80,
    height: 40,
    objectFit: "cover",
    cursor: "pointer",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 2,
  },
  clickablePlaceholder: {
    cursor: "pointer",
    color: theme.palette.primary.main,
    textDecoration: "underline",
    fontSize: "0.85rem",
  },
  nonClickablePlaceholder: {
    color: theme.palette.text.secondary,
    fontStyle: "italic",
    fontSize: "0.85rem",
  },
  noPlateChip: {
    backgroundColor: fade(theme.palette.warning.main, 0.15),
    color: theme.palette.type === "dark" ? theme.palette.warning.light : theme.palette.warning.main,
    borderRadius: 8,
    marginLeft: theme.spacing(0.5),
    height: 20,
    fontSize: "0.7rem",
  },
}));
